<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">CONSOLIDADO PRODUCCION POR DIA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>                
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card> 
            <v-card-text>
                <v-row>
                    <v-col cols="2" sm="3">
                        <date-picker class="ml-2" v-model="rango_fechas" @change="cargarTodo" placeholder="Rango de Fechas a Mostrar" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2" sm="3">
                        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                        <v-btn v-if="(role != null) && (role=='Produccion')" dark color="orange darken-1" @click="abrir_modal_registro_prod()">Registrar Producción Harina</v-btn>
                    <v-col>
                </v-col>
                    </v-col>
                    <v-col cols="8" sm="6" v-if="alert">
                        <v-alert dense text type="success">
                        Bitácora Consolidada !! <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        
        <!-- detalle jumbos -->
        <v-card>
            <v-simple-table
                fixed-header
                width="100%"
                height="90vh"
            >
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="indigo darken-2" colspan="4"></th>
                        <th class="text-center blue darken-3 borde-left" colspan="6">SISTEMA</th>
                        <th class="text-center indigo darken-2 borde-left" colspan="3">PRODUCCION</th>
                        <th class="text-center blue darken-3 borde-left" colspan="4">TRAZABILIDAD</th>
                    </tr>
                    <tr>
                        <th class="text-center indigo darken-2">Fecha</th>
                        <th class="text-center indigo darken-2">Estado Bitácora</th>
                        <th class="text-center indigo darken-2">Linea</th>
                        <th class="text-center indigo darken-2">Proceso</th>

                        <th class="text-center blue darken-3 borde-left">Maxisacos</th>
                        <th class="text-center blue darken-3 borde-left">Prod.</th>
                        <th class="text-center blue darken-3">Total Kilos</th>
                        <th class="text-center blue darken-3">Barridos</th>
                        <th class="text-center blue darken-3"> Repasos </th>
                        <th class="text-center blue darken-3">Reprocesos</th>

                        <th class="text-center indigo darken-2 borde-left">Maxisacos</th>
                        <th class="text-center indigo darken-2">Kilos</th>
                        <th class="text-center indigo darken-2">Materia Prima</th>

                        <th class="text-center blue darken-3 borde-left">Maxisacos</th>
                        <th class="text-center blue darken-3">Materia Prima</th>
                        <th class="text-center indigo darken-2">Bloqueo Trazabilidad</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,idx) in lista" :key="idx" :class="item.color">
                        <td class="text-center">{{item.fecha | formatearFecha}}</td>
                        <td class="text-center"> 
                            <v-btn v-if="(item.consolidado == 0) && (item.role == 'Laboratorio')" title="Por Validar" color="red" @click="consolidar(item.fecha)" icon><v-icon dark>block</v-icon></v-btn>
                            <v-btn v-if="(item.consolidado == 0) && (item.role != 'Laboratorio')" title="Por Validar" color="red" icon><v-icon dark>block</v-icon></v-btn>
                            <v-btn v-if="(item.consolidado == 1) && (item.role != 'Laboratorio')" title="Validada (Bloqueada)" color="green" icon><v-icon dark>check</v-icon></v-btn> 
                            <v-btn v-if="(item.consolidado == 1) && (item.role == 'Laboratorio')" title="Validada (Bloqueada)" color="green" @click="desbloquear(item.fecha)" icon><v-icon dark>check</v-icon></v-btn>
                        </td>
                        <td class="text-center">{{item.linea}}</td>
                        <td class="text-center">{{item.proceso_jumbo}}</td>
                        <td class="text-right borde-left">{{item.nro_jumbo}} <v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-right">{{item.jumbos_prod}}</td>
                        <td class="text-right">{{item.jumbos_peso | formatear_miles}}</td>
                        <!-- <td class="text-right">{{item.barrido}} <v-btn v-if="(item.lotes_barrido != ',') && (item.lotes_barrido != '')" @click="verJumbos2(item.lotes_barrido)" icon><v-icon>visibility</v-icon></v-btn> </td> -->
                        <!-- <td class="text-right">{{item.repasado}}<v-btn v-if="(item.lotes_repaso != ',') && (item.lotes_repaso != '')" @click="verJumbos2(item.lotes_repaso)" icon><v-icon>visibility</v-icon></v-btn></td> -->
                        <!-- <td class="text-right">{{item.movimiento}} <v-btn v-if="(item.lotes_reproceso != ',') && (item.lotes_reproceso != '')" @click="verJumbos2(item.lotes_reproceso)" icon><v-icon>visibility</v-icon></v-btn></td> -->
                        <td class="text-right">{{item.barrido}} <v-btn v-if="(item.lotes_barrido != ',') && (item.lotes_barrido != '')" @click="verJumbos(item, 'barrido')" icon><v-icon>visibility</v-icon></v-btn> </td>
                        <td class="text-right">{{item.repasado}}<v-btn v-if="(item.lotes_repaso != ',') && (item.lotes_repaso != '')" @click="verJumbos(item, 'repaso')" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-right">{{item.movimiento}} <v-btn v-if="(item.lotes_reproceso != ',') && (item.lotes_reproceso != '')" @click="verJumbos(item, 'reproceso')" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-right borde-left">{{item.maxis_prod}}</td>
                        <td class="text-right">{{item.pts_prod | formatear_miles}}</td>
                        <td :class="[((item.jumbos_prod != 0) && (item.mps_prod == 0)) ? 'text-right orange accent-1' : 'text-right']">{{item.mps_prod | formatear_miles}}</td>
                        <td :class="[(item.jumbos_prod != item.maxis_traza) ? 'text-right orange accent-1' : 'text-right']">{{item.maxis_traza}}</td>
                        <td :class="[((item.mps_prod != 0) && (item.mps_traza != item.mps_prod) && ((item.mps_traza - item.mps_prod > 9) || (item.mps_traza - item.mps_prod < -9))) ? 'text-right orange accent-1' : 'text-right']">{{item.mps_traza | formatear_miles}}</td>

                        <td class="text-center"> 
                            <v-btn v-if="(item.trazabilidad_consolidada == 0) && (item.role == 'Laboratorio')" title="Desbloqueada" color="green" @click="cambiarEstadoTrazabilidad(item.fecha, item.trazabilidad_consolidada)" icon><v-icon dark>check</v-icon></v-btn>
                            <v-btn v-if="(item.trazabilidad_consolidada == 0) && (item.role != 'Laboratorio')" title="Desbloqueada" color="green" icon><v-icon dark>check</v-icon></v-btn>

                            <v-btn v-if="(item.trazabilidad_consolidada == 1) && (item.role != 'Laboratorio')" title="Bloqueada" color="red" icon><v-icon dark>block</v-icon></v-btn> 
                            <v-btn v-if="(item.trazabilidad_consolidada == 1) && (item.role == 'Laboratorio')" title="Bloqueada" color="red" @click="cambiarEstadoTrazabilidad(item.fecha, item.trazabilidad_consolidada)" icon><v-icon dark>block</v-icon></v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
            </v-simple-table>
        </v-card>
        
        <!-- <pre>{{lista}}</pre> -->

        <v-dialog
            v-model="abrir_modal"
            width="500"
        >
            <v-card>
                <v-card-title primary-title>
                    <v-list-item-content>
                        <v-list-item-title class="text-h5 mb-1">
                            Detalle de Maxisacos
                        </v-list-item-title>
                        <v-list-item-subtitle :style="{textTransform: 'capitalize'}">
                            {{ `${maxisacos_seleccionados.general.linea || ''} - ${maxisacos_seleccionados.general.materia_prima || ''} - ${maxisacos_seleccionados.general.filtro || 'todos'}`  }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-card-title>

                <v-card-text>
                    <v-simple-table class="table-summary-maxis">
                        <thead>
                            <tr>
                                <th class="text-center cabecera">Lote</th>
                                <th class="text-center cabecera">Maxisacos</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(pm, lote) in maxisacos_seleccionados.data">
                                <td class="text-no-wrap"> {{ lote }} </td>
                                <td class="jumbos-container">
                                    <template v-for="(jumbo, i) in pm">
                                        <span :class="jumbo.barrido && 'jumbos-container__jumbo-barrido'" :title="jumbo.barrido ? 'Maxisaco de barrido' : ''">
                                            {{jumbo.nro_jumbo}}
                                            <template v-if="i + 1 < pm.length">,</template>
                                        </span> 
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="abrir_modal2"
            width="500"
        >

            <v-card>
                <v-card-title
                    class="headline indigo lighten-2"
                    primary-title
                    >
                    Detalle de Maxisacos
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                            {{`${lotes_maxisacos}`}}
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal2 = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    <!-- detalle jumbos -->

    <!-- produccion-harina-dia  -->
    <produccion-harina-dia></produccion-harina-dia>

    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import ProduccionHarinaDia from '@/components/shared/Produccion_Harina_Dia.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
// import axios from 'axios'
export default {
    data:()=>({
        turno: [],
        role: 'Otro',
        lista:[],
        jumbos_sin_asignar:[],
        jumbos_reprocesados:[],
        jumbos_de_barrido:[],
        turnos: [],
        alert:false,
        fecha: new Date().toISOString().substr(0, 10),
        rango_fechas:'',
        mostrar_fecha: false,
        abrir_modal:false,
        abrir_modal2:false,
        produccion:{},
        lotes_maxisacos:'',
        maxisacos_seleccionados: {
            general: {},
            data: {},
        },
        //configuracion para datatable
        cabeceras:[
            {
                text: 'Linea',
                align: 'center',
                sortable: true,
                value: 'linea',
            },
            {
                text: 'Maxisacos',
                align: 'center',
                sortable: true,
                value: 'jumbos',
            },
            {
                text: 'Materia prima',
                align: 'center',
                sortable: true,
                value: 'materia_prima',
            },
            {
                text: 'Cantidad Maxisacos',
                align: 'center',
                sortable: true,
                value: 'cantidad_jumbos',
            },
            {
                text: 'Total Kilos',
                align: 'center',
                sortable: true,
                value: 'total_kg',
            }
        ],
        acciones:[],
        detalle_lineas: [],
    }),
    mounted() {
        //this.cargarTurnos();
        this.cargarProduccionDiaria();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Consolidado Producción Por Día`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un resumen de la producción consolidada diariamente según el rango de fechas indicado.`},
                {   tipo:`label`,   texto:`- En la tabla se muestra información relevante dividida por secciones: Sistema, Producción y Trazabilida, en la que se puede hacer una comparativa de las cantidades de maxisacos, de los kilos producidos y demás entre cada sección. Además, la primera sección indica a qué día, línea y proceso corresponde ese registro con datos.`},
                {   tipo:`label`,   texto:`- En la columna "Estado Bitácora" ( insert_img_help-consolidado-diario_ic1.png?width=50px ), se indica si la bitácora de ese día está bloqueada o si se desea bloquear/desbloquear la bitácora (pulsando el icono de esa fila).`},
                {   tipo:`label`,   texto:`- En la columna "Bloqueo Trazabilidad" ( insert_img_help-consolidado-diario_ic2.png?width=60px ), se indica si la trazabilidad de ese día está bloqueada o si se desea bloquear/desbloquear la trazabilidad (pulsando el icono de esa fila) para que no se pueda cambiar al momento de registrar la producción de ese día en la pantalla de registro de producción dentro del Reporte de Producción Diaria.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
 
        cargarTodo() {
            this.cargarDatos();
            this.cargarProduccionDiaria();
        },

        async cargarDatos(){
            this.lista = [];
            this.mostrarLoading('Cargando Datos...');
            let fecha_ini = this.rango_fechas[0];
            let fecha_fin = this.rango_fechas[1];
            let url = `${this.base_url}produccion/consolidar_todo/${fecha_ini}/${fecha_fin}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista = response.data.data;
                this.role = response.data.role;
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar datos ");
            });
        },

        async consolidar(fecha){
            
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Consolidar Bitácora',
                message: `CONFIRMA CONSOLIDACIÓN BITÁCORA FECHA ${ this.moment(fecha).format('DD-MM-YYYY')} ?`,
                okButton: 'Consolidar !!',
            })
            if(okei) {
                this.mostrarLoading('Enviando Información...');
                let body = {
                        fecha:fecha,
                        fecha_ini:this.rango_fechas[0],
                        fecha_fin:this.rango_fechas[1],
                    }
                let url = `${this.base_url}consolidar/bitacora`;
                await this.axios.post(url,body,this.headers).then((res)=>{
                    this.cargarDatos();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al consolidar fecha");
                    console.log(e);
                })
            }
        },

        async desbloquear(fecha){
            
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Desbloquear Bitácora',
                message: `CONFIRMA DESBLOQUEO DE BITÁCORA FECHA ${ this.moment(fecha).format('DD-MM-YYYY')} ?`,
                okButton: 'DESBLOQUEAR !!',
            })
            if(okei) {
                this.mostrarLoading('Enviando Información...');
                let body = {
                        fecha:fecha,
                        fecha_ini:this.rango_fechas[0],
                        fecha_fin:this.rango_fechas[1],
                    }
                let url = `${this.base_url}desbloquear/bitacora`;
                await this.axios.post(url,body,this.headers).then((res)=>{
                    this.cargarDatos();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al desbloquear fecha");
                    console.log(e);
                })
            }
        },

        async cambiarEstadoTrazabilidad(fecha, estado) {
            const msg = {
                title: `${estado === 1 ? 'Desbloquear ' : 'Bloquear'}`,
                message: `${estado === 1 ? 'Desbloqueo ' : 'Bloqueo'}`,
            }
            const ok = await this.$refs.confirmDialogue.show({
                title: `${msg.title} trazabilidad` ,
                message: `CONFIRMA ${msg.message.toUpperCase()} DE TRAZABILIDAD FECHA ${ this.moment(fecha).format('DD-MM-YYYY')} ?`,
                okButton: `${msg.title.toUpperCase()} !!`,
            });
            if(ok) {
                this.mostrarLoading({titulo: 'Enviando Información...', color: 'green'});
                const body = {
                    fecha: fecha,
                    fecha_ini: this.rango_fechas[0],
                    fecha_fin: this.rango_fechas[1],
                    nuevo_estado: estado === 1 ? 0 : 1,
                }
                const url = `${this.base_url}cambiar_estado/trazabilidad`;
                await this.axios.post(url,body,this.headers).then(res => {
                    this.cargarDatos();
                }).catch((e)=>{
                    this.errorMessage(e, `Error al ${msg.title.toLowerCase()} fecha`);
                    console.log(e);
                });
            }
        },

        verJumbos(item, filtro){
            console.log(item);
            this.produccion = item;
            if(filtro) {
                const lotes_filtrados = {};
                Object.entries(item.lotes).forEach(([lote, jumbos]) => {
                    jumbos = jumbos.filter(jumbo => jumbo[filtro]);
                    if(jumbos.length > 0) {
                        lotes_filtrados[lote] = jumbos;
                    }
                });
                this.maxisacos_seleccionados.data = lotes_filtrados;
            } else {
                this.maxisacos_seleccionados.data = item.lotes;
            }

            this.maxisacos_seleccionados.general = {
                linea: `Línea ${item.linea}`,
                materia_prima: item.proceso_jumbo,
                filtro,
            }
            this.abrir_modal = true;
        },
        
        verJumbos2(item){
            console.log(item);
            this.lotes_maxisacos = item.join(', ');
            this.abrir_modal2 = true;
        },

        abrir_modal_registro_prod(){
            Event.$emit('abrir_modal_produccion_harina_dia', this.detalle_lineas, this.rango_fechas[0] || this.fecha);
        },

        async cargarProduccionDiaria(){
            // await this.cargarRecepciones();
            this.mostrarLoading({titulo:'Cargando Producción...',color:'green'})

            let url = `${this.base_url}produccion_diaria/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.detalle_lineas = res.data.detalle_lineas;
                this.ocultarLoading();
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar produccion diaria ");
            });
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),

        
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        DatePicker,
        ConfirmDialogue,
        'produccion-harina-dia':ProduccionHarinaDia,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
    .container{max-width: 98%!important;}
    input[type=number]{
        text-align: right;
    }
    th {color: white !important; font-size: 0.9em !important; }
    .borde-left{border-left: 0px solid white !important;}
    .filapar{
        background-color: #80DEEA;
    }
    .filaimpar{
        background-color:#80CBC4;
    }
/**quitar las flechitas */
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.table-summary-maxis {
    border: thin solid rgba(0, 0, 0, 0.12) !important;
}

.table-summary-maxis td {
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}

</style>